import * as React from "react"
import { SaTitle } from "../saTitle/saTitle"
// @ts-ignore
import {saVideoSlider,saTitleContainer,saTitle,saSubtitleContainer,saSubtitle,saBackground} from './saVideoSlider.module.scss'
import SaSlider from "./saSlider"
import { saInterfaceVideoSliderContainer } from "../saTypes"
import { SaSubtitle } from "../saTitle/saSubtitle"
import { SaSlideItem } from "./saSlideItem"



export const SaVideoSlider:React.FC<saInterfaceVideoSliderContainer> = ({ ...props }) => {


    let count = Object(props.blocks).length


    return (
      <div className={'saContainer ' + saVideoSlider}>

        {
          props.sectionTitle &&
          <div className={saTitleContainer}>
            <SaTitle title={props.sectionTitle} classes={saTitle}/>
          </div>
        }

        {
          props.subtitle &&
          <div className={saSubtitleContainer}>
            <SaSubtitle title={props.subtitle} classes={saSubtitle}/>
          </div>
        }


        {
          props.blocks &&
          <div className={saBackground} >
            {
              (count == 1) &&
              <SaSlideItem {...props.blocks[0]}/>
            }
            {
              (count > 1) &&
              <SaSlider {...props.blocks}/>
            }
          </div>
        }


      </div>
    )

}
